import { tr } from '@repo/locale';
import { type TestId } from '@repo/test-id';
import { VEHICLE_NAME_MAX_LENGTH } from '@repo/domain';
import { Input } from '@repo/ui';
import { VehicleRegistrationInput } from '@repo/entities';

interface Props {
  registrationNumber: string;
  onRegistrationNumberChange: (value: string) => void;
  vehicleName: string;
  onVehicleNameChange: (value: string) => void;
  testId: TestId;
  showNameField?: boolean;
}

export default function VehicleFieldGroup({
  registrationNumber,
  onRegistrationNumberChange,
  vehicleName,
  onVehicleNameChange,
  testId,
  showNameField = true,
}: Props) {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2.5">
        <div className="flex items-center justify-start gap-1">
          <div className="flex items-center justify-start gap-0.5">
            <div className="text-heading text-sm leading-5 font-medium">
              {tr('reservations:no_vehicle_exists_page.registration_number_label')}
            </div>
            <div className="text-fg-danger text-sm leading-5 font-medium">*</div>
          </div>
        </div>
        <VehicleRegistrationInput
          testId={testId.append('registrationNumber')}
          value={registrationNumber}
          onChange={onRegistrationNumberChange}
        />
      </div>

      {showNameField && (
        <div className="flex flex-col gap-1">
          <div className="inline-flex items-center justify-between">
            <div className="text-heading text-sm leading-5 font-medium">
              {tr('reservations:no_vehicle_exists_page.vehicle_name_label')}
            </div>
            <div className="text-body-subtle text-xs leading-4 font-normal">
              {tr('reservations:no_vehicle_exists_page.vehicle_name_optional')}
            </div>
          </div>
          <Input
            testId={testId.append('vehicleName')}
            placeholder={tr('reservations:no_vehicle_exists_page.vehicle_name_placeholder')}
            value={vehicleName}
            onChange={onVehicleNameChange}
            maxLength={VEHICLE_NAME_MAX_LENGTH}
          />
        </div>
      )}
    </div>
  );
}
